import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
    Grid,
    Row,
    Col
} from 'react-bootstrap';

import DeleteUserForm from '../../components/DeleteUser/DeleteUserForm';

import cs from '../../components/commonStyle.css'
import s from './deleteUser.css';

const DeleteUser = () => {
    return (
        <Grid fluid className={'listingContainer'}>
            <Row>
                <Col xs={12} sm={12} md={8} lg={8} className={cs.spaceTop6}>
                    <DeleteUserForm />
                </Col>
            </Row>
        </Grid>
    );
}

export default withStyles(cs, s)(DeleteUser);